import { Rule } from 'antd/lib/form';
import _ from 'lodash';
import { Trans } from 'react-i18next';
import { NumberHelper } from 'src/utils/NumberHelper';

export enum FieldMaxLength {
    Default = 100,
}

const required: Rule = {
    required: true,
    message: <Trans i18nKey="Form.Rules.Validator.Messages.Required" />,
};

const email: Rule = {
    type: 'email',
    message: <Trans i18nKey="Form.Rules.Validator.Messages.EmailError" />,
};

const greaterThanZero: Rule = {
    validator: (_rule, value: number) => {
        return new Promise((resolve, reject) => {
            if (_.isNumber(value) && value <= 0) {
                reject(
                    <Trans i18nKey="Form.Rules.Validator.Messages.GreaterThanZeroError" />,
                );
            } else {
                resolve(true);
            }
        });
    },
};

const greaterThanZeroOrZero: Rule = {
    validator: (_rule, value: number) => {
        return new Promise((resolve, reject) => {
            if (_.isNumber(value) && value < 0) {
                reject(
                    <Trans i18nKey="Form.Rules.Validator.Messages.GreaterThanZeroOrZeroError" />,
                );
            } else {
                resolve(true);
            }
        });
    },
};

const numberMinValue = (min = 0) => {
    return {
        validator: (_: any, value: number) => {
            return new Promise((resolve, reject) => {
                if (value < min) {
                    reject(
                        <Trans
                            i18nKey="Form.Rules.Validator.Messages.NumberMinValueError"
                            values={{
                                min: NumberHelper.formatNumberWithDivider(min),
                            }}
                        />,
                    );
                } else {
                    resolve(true);
                }
            });
        },
    };
};

const numberMaxValue = (max = 100) => {
    return {
        validator: (_: any, value: number) => {
            return new Promise((resolve, reject) => {
                if (value > max) {
                    reject(
                        <Trans
                            i18nKey="Form.Rules.Validator.Messages.NumberMaxValueError"
                            values={{
                                max: NumberHelper.formatNumberWithDivider(max),
                            }}
                        />,
                    );
                } else {
                    resolve(true);
                }
            });
        },
    };
};

const maxFieldLength = (
    maxLength: number | FieldMaxLength = FieldMaxLength.Default,
) => {
    return {
        validator: (_: any, value: string) => {
            return new Promise((resolve, reject) => {
                if (!value?.length || value?.length <= maxLength) {
                    resolve(true);
                } else {
                    reject(
                        <Trans
                            i18nKey="Form.Rules.Validator.Messages.MaxFieldLength"
                            values={{ maxLength }}
                        />,
                    );
                }
            });
        },
    };
};

const digits = (numbers: number, digits: number) => {
    return {
        pattern: new RegExp(`^\\d{1,${numbers}}(\\.\\d{1,${digits}})?$`),
        message: (
            <Trans
                i18nKey="Form.Rules.Validator.Messages.FractionalDigits"
                values={{
                    numbers,
                    digits,
                }}
            />
        ),
    } as Rule;
};

export const ValidationRules = {
    required,
    email,
    greaterThanZero,
    greaterThanZeroOrZero,
    numberMinValue,
    numberMaxValue,
    maxFieldLength,
    digits,
};
